import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {FilterKey, keyToEmptyFilter, SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';
import {WorklistTypeToModelTypes} from 'worklists/WorklistConstants';

export function getDefaultWorklistSearchParams(): SearchParams {
  return {
    filters: [
      {
        ...keyToEmptyFilter(FilterKey.TYPES),
        value: [ModelTypeConstants.WORKLIST],
      },
    ],
    offset: 0,
    limit: getSelectedPageSize(),
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.WORKLISTS),
  };
}

export function getDefaultWorklistItemsSearchParams(): SearchParams {
  return {
    filters: [
      {
        ...keyToEmptyFilter(FilterKey.TYPES),
        value: ([] as Array<string>).concat(...Object.values(WorklistTypeToModelTypes)),
      },
    ],
    offset: 0,
    limit: getSelectedPageSize(),
    query: '',
    sorts: [],
  };
}
